import React, { useState, useCallback } from 'react'
import Modal from 'react-modal'
import Pulse from './pulse'
import PulseAnonymous from './pulse-anonymous'
import { useQuery } from '@apollo/client'
import findPulse from '../queries/find-pulse'

const className = {
  base: 'full-modal',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

const PulseModal = ({ id, onClose, setViewReflectionsStudent }) => {
  const [anonymous, setAnonymous] = useState(true)
  const [searchText, setSearchText] = useState('')

  const { data } = useQuery(findPulse, {
    pollInterval: 5000,
    skip: !id,
    variables: { id },
  })

  const handleClose = useCallback(
    (e) => {
      e.preventDefault()
      setAnonymous(true)
      onClose(null)
    },
    [onClose]
  )

  const toggleAnonymous = useCallback(() => {
    setAnonymous((prevAnonymous) => !prevAnonymous)
  }, [])

  const handleSetViewReflectionsStudent = useCallback(
    (student) => {
      setViewReflectionsStudent(student)
      setTimeout(() => onClose(null), 300)
    },
    [setViewReflectionsStudent, onClose]
  )

  if (!data || !data.findPulse) {
    return <span>nothing</span>
  }

  const { findPulse: assignment } = data
  const title = anonymous ? 'The Pulse (Anonymized)' : 'The Pulse'

  return (
    <Modal
      isOpen={!!assignment}
      onRequestClose={handleClose}
      contentLabel="Pulse Modal"
      className={className}
      overlayClassName={overlayClassName}
      appElement={document.getElementById('project-form')}
    >
      <header className="full-modal-header">
        <a href="/" className="logo">
          <img src="/images/logo.png" className="logo" alt="" />
        </a>
        <h2>{title}</h2>
        <nav role="navigation" aria-label="App Navigation">
          <a href="#" onClick={handleClose}>
            Close
            <i className="material-icons">close</i>
          </a>
        </nav>
      </header>
      {anonymous ? (
        <PulseAnonymous
          assignment={assignment}
          toggleAnonymous={toggleAnonymous}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      ) : (
        <Pulse
          assignment={assignment}
          toggleAnonymous={toggleAnonymous}
          searchText={searchText}
          setSearchText={setSearchText}
          setViewReflectionsStudent={handleSetViewReflectionsStudent}
          returnTo={() => onClose(assignment)}
        />
      )}
    </Modal>
  )
}

export default PulseModal
